import axios from 'axios';
import { API_BASE_URL } from './config/api';

// Fonction pour convertir une data URI en Blob
const dataURItoBlob = (dataURI) => {
  const [header, base64Data] = dataURI.split(',');
  const isBase64 = header.indexOf('base64') >= 0;
  let byteString;
  if (isBase64) {
    byteString = atob(base64Data);
  } else {
    byteString = decodeURIComponent(base64Data);
  }
  const mimeString = header.split(':')[1].split(';')[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
};

const EXT_PAR_TYPE = {
  'image/jpeg': 'jpg',
  'image/png': 'png',
  'application/pdf': 'pdf',
};

// Le type MIME peut être VIDE : c'est courant sur certains navigateurs Android et
// sur les fichiers ouverts depuis un cloud. On retombe alors sur l'extension du nom.
//
// Pourquoi cela compte : le backend force la photo en 'photo.jpg' mais CONSERVE
// l'extension d'origine pour le passeport (server.js, « 'passeport' +
// path.extname(originalname) »). Un repli sur '.bin' produisait donc un
// passeport.bin sur le serveur, que ni l'admin ni le consulat ne savent ouvrir.
const extensionDuFichier = (typeMime, nomFichier) => {
  const parType = EXT_PAR_TYPE[typeMime];
  if (parType) return parType;

  const trouve = /\.([a-z0-9]+)$/i.exec(nomFichier || '');
  const ext = trouve ? trouve[1].toLowerCase() : '';
  if (ext === 'jpeg') return 'jpg';
  if (ext === 'jpg' || ext === 'png' || ext === 'pdf') return ext;

  // DocumentPicker n'a laissé passer que JPEG, PNG ou PDF : 'jpg' est le repli
  // le moins risqué, et de loin préférable à une extension inconnue.
  return 'jpg';
};

// Ajoute un document au FormData.
// Chemin PRÉFÉRÉ : l'objet File conservé par DocumentPicker. Il évite le
// `fetch(blob:...)` de reconversion ci-dessous, qui échoue sans le moindre signal
// sur iOS quand Safari purge la page pendant la prise de vue — l'URL blob: est
// alors morte et l'appel rejette. Le repli reste nécessaire pour les data: URI.
const ajouterFichier = async (formData, champ, uri, fichier) => {
  if (typeof File !== 'undefined' && fichier instanceof File) {
    formData.append(champ, fichier, `${champ}.${extensionDuFichier(fichier.type, fichier.name)}`);
    return;
  }

  if (!uri) {
    throw new Error(`Document manquant : ${champ}`);
  }

  let blob;
  if (uri.startsWith('data:')) {
    blob = dataURItoBlob(uri);
  } else {
    const reponse = await fetch(uri);
    blob = await reponse.blob();
  }
  formData.append(champ, blob, `${champ}.${extensionDuFichier(blob.type, uri)}`);
};

const creationVoyageur = async (data) => {
  const formData = new FormData();

  // Champs texte
  formData.append('nom', data.nom);
  formData.append('prenom', data.prenom);
  formData.append('idUtilisateur', data.idUtilisateur);
  formData.append('adresse', data.adresse);
  formData.append('codePostal', data.codePostal);
  formData.append('ville', data.ville);
  formData.append('profession', data.profession);
  formData.append('telephone', data.telephone);
  formData.append('etatCivil', data.etatCivil);

  await ajouterFichier(formData, 'photo', data.photoUri, data.photoFile);
  await ajouterFichier(formData, 'passeport', data.passeportUri, data.passeportFile);

  // Le catch NE DOIT PAS avaler l'erreur. Sans `throw`, l'`await` de l'appelant se
  // résolvait même sur un 500 : VoyageurInsert naviguait alors comme si le voyageur
  // avait été créé, et toute l'étape « profil voyageur » se cochait dans le vide.
  // Le `return` rend par ailleurs l'identifiant créé disponible à l'appelant.
  try {
    const response = await axios.post(
      `${API_BASE_URL}/insertVoyageur`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error('Erreur lors de la création du voyageur:', error);
    throw error;
  }
};

export default creationVoyageur;
